export enum GasStationBrand {
  GAZPROM = "GAZPROM",
  LUKOIL = "LUKOIL",
  ROSSETI = "ROSSETI",
}
